import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail, Phone, MapPin, Linkedin, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <img 
                src="https://customer-assets.emergentagent.com/job_selected-repo/artifacts/x30z79ye_IMG_1165.PNG" 
                alt="Arihant Milk Products" 
                className="h-20 w-auto object-contain"
                style={{ background: 'transparent' }}
              />
            </div>
            <p className="text-gray-600 text-sm">
              Premium dairy products made with love and tradition. Quality you can trust, taste you can enjoy.
            </p>
            <div className="flex space-x-4">
              <a href="https://facebook.com/arihantmilkproducts" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-rose-600 transition-colors duration-200">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="https://instagram.com/arihantmilkproducts" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-rose-600 transition-colors duration-200">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="https://www.linkedin.com/in/rajat-surana-4272616b/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-rose-600 transition-colors duration-200">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="https://www.youtube.com/channel/UCS7oTpz-tJOOuKIzXiqYk6Q" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-rose-600 transition-colors duration-200">
                <Youtube className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-600 hover:text-rose-600 text-sm transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-600 hover:text-rose-600 text-sm transition-colors duration-200">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/mission" className="text-gray-600 hover:text-rose-600 text-sm transition-colors duration-200">
                  Our Mission and Vision
                </Link>
              </li>
              <li>
                <Link to="/team" className="text-gray-600 hover:text-rose-600 text-sm transition-colors duration-200">
                  Our Team
                </Link>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Products</h3>
            <ul className="space-y-2">
              <li className="text-gray-600 text-sm">Premium Ghee</li>
              <li className="text-gray-600 text-sm">Milk Powder</li>
              <li className="text-gray-600 text-sm">Fresh Butter</li>
              <li className="text-gray-600 text-sm">Paneer & Cheese</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3 text-sm text-gray-600">
                <MapPin className="h-5 w-5 text-rose-600 flex-shrink-0 mt-0.5" />
                <span>ARIHANT MILK PRODUCTS UNIT 2, 7 km stone, Halka No. 29, Survey no. 37/1-37/6 Gram: Kapaliya Khedi By pass to 8, Nemawar Rd, Indore, Madhya Pradesh 452016</span>
              </li>
              <li className="flex items-center space-x-3 text-sm text-gray-600">
                <Phone className="h-5 w-5 text-rose-600 flex-shrink-0" />
                <span>0731 2431576</span>
              </li>
              <li className="flex items-center space-x-3 text-sm text-gray-600">
                <Mail className="h-5 w-5 text-rose-600 flex-shrink-0" />
                <span>samarthsurana@arihantmilkproducts.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-8 pt-8 text-center">
          <p className="text-gray-600 text-sm">
            © {new Date().getFullYear()} Arihant Milk Products. All rights reserved. Made with care for quality.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
